module.exports = __webpack_public_path__ + "static/media/img-card-one.22af23b1.jpg";